<template>
  <div
    :class="`right-slider-notification ${isNotificationNav ? 'expand' : ''}`"
  >
    <div class="tw-flex tw-justify-end tw-pt-[52px] tw-pr-[40px]">
      <closeIcon :size="17" :color="'#231F20'" @click="emitCloseNotification" />
    </div>
    <div class="tw-p-10 main">
      <div class="tw-flex tw-items-center tw-gap-2 tw-mb-10">
        <bellIcon :width="17" :height="21" :color="'#211F58'" />
        <span
          class="tw-font-semibold tw-text-[#211f58] tw-text-[25px] title-text"
          >{{ getComponentUiText("app-notification-heading-1") }}</span
        >
      </div>
      <div class="tw-flex action-mobile">
        <searchInput
          v-model="searchText"
          :hint-text="
            getComponentUiText('app-prospect-questions-search-text-1')
          "
          :class="'tw-mr-[20px]'"
        />
        <!--
 <div class="margin-mobile">
          <ButtonFilter
            :active="true"
            :has-border="true"
            :change-color="true"
            :id-popover="'popover-btn-filter-notification'"
            :is-selected="getOptionFilter().length > 0"
          >
            <template #default>
              <CustomDropDownItem
                v-for="option in filterOptions"
                :key="option.id"
                :style="'normal'"
                :id-text="option.name"
                @click="onFilterOptionClick(option)"
              />
            </template>
          </ButtonFilter>
        </div> 
-->
        <ButtonSort
          :active="true"
          :has-border="true"
          :id-popover="'popover-btn-sort-notification'"
        >
          <template #default>
            <CustomDropDownItem
              :style="'normal'"
              :id-text="'app-notification-sort-date-1'"
              :add-icon="true"
              :trans-form-rotate="90"
              @click="sortNotificationBlock(false)"
            />
            <CustomDropDownItem
              :style="'normal'"
              :id-text="'app-notification-sort-date-1'"
              :add-icon="true"
              :trans-form-rotate="-90"
              @click="sortNotificationBlock(true)"
            />
          </template>
        </ButtonSort>
      </div>
      <div v-if="getOptionFilter().length > 0">
        <span
          v-for="option in getOptionFilter()"
          :key="option.id"
          class="tw-mt-[20px] tw-items-center tw-px-[13px] tw-py-[10px] tw-rounded-[100px] tw-border tw-border-[#211F58] tw-border-solid tw-text-[#211F58] tw-text-[11px] tw-font-medium tw-not-italic tw-leading-[130%] tw-inline-flex tw-mr-[10px]"
        >
          {{ getComponentUiText(option.name) }}
          <closeIcon
            :size="8"
            :h="8"
            :color="'#211F58'"
            :x1="7.11182"
            :y1="1"
            :w1="1.25702"
            :h1="10.0561"
            :y2="1.88672"
            :w2="1.25702"
            :h2="10.0561"
            class="tw-ml-[6px] tw-cursor-pointer"
            @click="removeOption(option)"
          />
        </span>
      </div>
      <div class="tw-mt-[40px] tw-flex tw-items-center">
        <div
          class="tw-inline-block tw-text-center tw-w-[38px] tw-cursor-pointer"
          @click="() => setIsAllNotificationOpen(true)"
        >
          <span
            :class="`tw-text-[14px] ${
              isAllNotificationOpen ? 'tw-text-[#387DFF]' : 'tw-text-[#231F20]'
            }  tw-font-medium tw-leading-[100%] tw-not-italic`"
            >{{
              getComponentUiText("app-notification-all-heading-option-block-1")
            }}</span
          >
          <div
            :class="`tw-h-[3px] tw-rounded-[5px] tw-w-[38px] tw-mt-[5px] ${
              isAllNotificationOpen ? 'tw-bg-[#387DFF]' : ''
            }`"
          />
        </div>
        <div
          class="tw-inline-block tw-text-center tw-ml-[15px] tw-w-[100px] tw-cursor-pointer"
          @click="() => setIsAllNotificationOpen(false)"
        >
          <span
            :class="`tw-text-[14px] ${
              !isAllNotificationOpen ? 'tw-text-[#387DFF]' : 'tw-text-[#231F20]'
            } tw-font-medium tw-leading-[100%] tw-not-italic`"
          >
            {{
              getComponentUiText(
                "app-notification-unread-heading-option-block-1",
              )
            }}
            <span
              v-if="getNumberUnread()"
              class="tw-text-[#01893D] tw-text-[10px] tw-uppercase tw-not-italic tw-leading-[100%] tw-font-bold tw-tracking-[1px] tw-ml-[7.5px] tw-rounded-[21px] tw-bg-[#D9EDE2] tw-px-[6px] tw-px-[2px]"
              >{{ getNumberUnread() }}</span
            >
          </span>
          <div
            :class="`tw-h-[3px] tw-rounded-[5px] ${
              !isAllNotificationOpen ? 'tw-bg-[#387DFF]' : ''
            }  tw-mt-[5px]`"
          />
        </div>
        <div class="tw-flex-1 tw-flex tw-justify-end show-more-notification">
          <ButtonShowMore
            :id-popover="'popover-btn-show-more-notification'"
            :is-from-notification="true"
          >
            <template #default>
              <CustomDropDownItem
                :style="'normal'"
                id-text="app-notification-mark-all-as-read-option-1"
                @click="markAllAsReadNotification"
              />
              <CustomDropDownItem
                :style="'danger'"
                id-text="app-notification-delete-all-option-1"
                @click="showConfirmModalDeleteAllNotifications"
              />
            </template>
          </ButtonShowMore>
        </div>
      </div>
      <div
        v-if="!loadingNotification"
        class="tw-overflow-y-auto tw-mt-[30px] tw-pb-[40px] scroll-css"
      >
        <div
          v-for="(block, index) in notificationBlocks.filter(
            (block) => block.notifications.length,
          )"
          :key="index"
        >
          <notificationBlocksUi
            :data="getDataFilter(block.notifications)"
            :title="block.title"
            :index="index"
            :sort-asc="sortByAsc"
          />
        </div>
      </div>
      <div
        v-else
        class="custom-global-skeleton tw-w-full tw-h-[72px] tw-rounded-[6px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import store from "../../store";
import utilities, { getComponentUiText } from "../../utils/utilities";
import { Ref, computed, onMounted, ref, watch } from "vue";
import searchInput from "../common/searchInput.vue";
import ButtonSort from "../common/setting/buttonSort.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import closeIcon from "@/components/svgs/closeIcon.vue";
import bellIcon from "@/components/svgs/bellIcon.vue";
import notificationBlocksUi from "./notificationBlock.vue";
import { IApiPromise } from "@/interfaces/responseData";
import get from "lodash/get";
import { UserRoute, Org } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import { getOrgIdProfile, getProfileImage } from "@/services/org";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME } from "@/utils/constants";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
const props = defineProps({
  isNotificationNav: {
    type: Boolean,
    required: false,
  },
});

// TODO: TEMPORARY
const filterOptions = [
  {
    id: 1,
    name: "app-notification-filter-option-1",
  },
  {
    id: 2,
    name: "app-notification-filter-option-1",
  },
  {
    id: 3,
    name: "app-notification-filter-option-1",
  },
  {
    id: 4,
    name: "app-notification-long-filter-option-1",
  },
];
const currentUser = computed(() => store.state.User.currentUser);
const notifications: any = computed(() =>
  store.state.Notification.notification.map((item: any) => {
    const name =
      item.checklistRequestedProviderName ||
      item.orgToOrgRequestOrg1Name ||
      item.orgToOrgOfferOrg1Name;

    const userImage = listAvatar.value.find(
      (avatar) =>
        avatar.orgId === item.orgToOrgOfferOrg1Id ||
        avatar.orgId === item.orgToOrgRequestOrg1Id,
    )?.avatarUrl;

    return {
      ...item,
      user: {
        companyName: currentUser.value.company || "",
        name: name || "",
        avatar: userImage || "",
      },
    };
  }),
);

let isAllNotificationOpen: Ref<boolean> = ref(true);
let searchText: Ref<string> = ref("");
let sortByAsc: Ref<boolean> = ref(false);

const loadingNotification = ref(true);
const filterOptionSelected = ref([]) as any;
const listAvatar: Ref<any[]> = ref([]);
const listProfile: Ref<any[]> = ref([]);

let notificationBlocks: any = computed(() => {
  let notificationTodayList = [] as any;
  let notificationYesterdayList = [] as any;
  let notificationThisWeekList = [] as any;
  let notificationThisMonthList = [] as any;
  let notificationOderList = [] as any;

  notifications.value.forEach((notification: any) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const notificationDate = new Date(notification.date_added);
    notificationDate.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);

    if (notificationDate.getTime() === today.getTime()) {
      notificationTodayList.push(notification);
    } else if (notificationDate.getTime() === yesterday.getTime()) {
      notificationYesterdayList.push(notification);
    } else if (notificationDate >= sevenDaysAgo) {
      notificationThisWeekList.push(notification);
    } else if (notificationDate >= thirtyDaysAgo) {
      notificationThisMonthList.push(notification);
    } else {
      notificationOderList.push(notification);
    }
  });

  let notificationBlocks = [
    {
      id: 1,
      title: "app-notification-today-block-1",
      notifications: notificationTodayList,
    },
    {
      id: 2,
      title: "app-notification-yesterday-block-1",
      notifications: notificationYesterdayList,
    },
    {
      id: 3,
      title: "app-notification-this-week-block-1",
      notifications: notificationThisWeekList,
    },
    {
      id: 4,
      title: "app-notification-this-month-block-1",
      notifications: notificationThisMonthList,
    },
    {
      id: 5,
      title: "app-notification-older-block-1",
      notifications: notificationOderList,
    },
  ];

  return notificationBlocks;
});

onMounted(() => {
  init();
});

watch(
  () => props.isNotificationNav,
  () => {
    if (props.isNotificationNav) {
      init();
    }
  },
);

const emit = defineEmits(["closeNotification"]);

const init = async () => {
  if (props.isNotificationNav) {
    loadingNotification.value = true;
    await store.dispatch("Notification/getNotification", {
      includeActioned: true,
    });
    await getListOrg();
    loadingNotification.value = false;
  }
};

const showConfirmModalDeleteAllNotifications = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-notification-modal-bulk-delete-option-title-1",
      ),
      description: getComponentUiText(
        "app-notification-modal-bulk-delete-option-description-1",
        false,
        {
          allText: {
            value: getComponentUiText(
              "app-notification-modal-bulk-delete-option-description-all-text-bold-1",
            ),
            css: "tw-text-[#231F20] tw-font-[600]",
          },
        },
      ),
      additionalNote: " ",
      buttonText: getComponentUiText(
        "app-notification-modal-bulk-delete-option-button-delete-1",
      ),
      buttonRed: true,
      modalContainerClass: "tw-z-[1101] tw-top-0",
    },
    events: {
      "update:data": deleteAllNotification,
    },
  };

  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const markAllAsReadNotification = async () => {
  await store.dispatch("Notification/markAllAsReadNotification");
};

const deleteAllNotification = async () => {
  await store.dispatch("Notification/deleteAllNotification");
};

const getListOrg = async () => {
  try {
    const orgIds = [
      ...new Set(
        notifications.value.map(
          (c) => c.orgToOrgOfferOrg1Id || c.orgToOrgRequestOrg1Id,
        ),
      ),
    ].filter((item) => item);

    await getOrgProfiles(orgIds);
    await getOrgAvatar();

    listAvatar.value = listAvatar.value.map((i) => {
      return {
        ...i,
        avatarUrl: URL.createObjectURL(
          utilities.base64ToFile(i.file, i.filename, i.fileType),
        ),
      };
    });
  } catch (error) {
    showErrorAPI(error, Org.getOrgProfile);
  }
};

const getOrgProfiles = async (orgIds: any[]) => {
  try {
    const listResult: any[] = [];
    const promise: IApiPromise<any>[] = [];
    orgIds.map((u) => promise.push(getOrgIdProfile(u)));

    const resArray = await Promise.allSettled(promise);
    resArray.forEach(
      (res) =>
        res.status === "fulfilled" &&
        listResult.push(get(res.value, "data.data", {})),
    );

    listProfile.value = listResult;
  } catch (error) {
    showErrorAPI(error, UserRoute.getUserProfile);
  }
};

const getOrgAvatar = async () => {
  const listResult: any[] = [];
  const promise: IApiPromise<any>[] = [];
  listProfile.value.map((u) =>
    promise.push(getProfileImage(u.avatar?.avatarImageFileId, u.orgId)),
  );

  const res = await Promise.allSettled(promise);
  res.forEach(
    (res) =>
      res.status === "fulfilled" &&
      listResult.push(get(res.value, "data.data", {})),
  );

  listAvatar.value = listResult;
};

const getNumberUnread = () => {
  const numberUnread = notifications.value.filter(
    (notification: any) => !notification.systemActionIsRead,
  );
  return numberUnread.length;
};

const getArrayUnread = (data) => {
  return data.filter((notification: any) => !notification.systemActionIsRead);
};

const sortNotificationBlock = (sortByAscValue: boolean) => {
  sortByAsc.value = sortByAscValue;

  const sortedBlocks = JSON.parse(JSON.stringify(notificationBlocks.value));

  sortedBlocks.sort((a, b) => {
    return sortByAscValue ? b.id - a.id : a.id - b.id;
  });

  notificationBlocks = ref(sortedBlocks);
};

const getDataFilter = (data: any) => {
  const dataKey = ["notes", "user.name"];
  const sortKey = "date_added";
  const filteredData: any[] = utilities.searchFilter(
    data,
    dataKey,
    searchText.value,
    sortByAsc.value,
    sortKey,
  );

  if (isAllNotificationOpen.value) {
    return filteredData;
  } else {
    return getArrayUnread(filteredData);
  }
};

const setIsAllNotificationOpen = (value) => {
  isAllNotificationOpen.value = value;
};

const emitCloseNotification = () => {
  emit("closeNotification");
};

const getOptionFilter = () => {
  return filterOptionSelected.value;
};

const onFilterOptionClick = (option: any) => {
  const duplicate = filterOptionSelected.value.filter(
    (item: any) => item.id === option.id,
  );
  if (duplicate && duplicate.length > 0) {
    return;
  }
  filterOptionSelected.value.push(option);
};

const removeOption = (option: any) => {
  filterOptionSelected.value = filterOptionSelected.value.filter(
    (item: any) => item.id !== option.id,
  );
};
</script>
<style scoped lang="scss">
.right-slider-notification {
  max-width: 640px;
  width: 0%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1100;
  /* > z-index modal = 1061 */
  background: #ffffff;
  overflow: hidden;
}

.right-slider-notification.expand {
  width: 100%;
}

.right-slider-notification.expand .main {
  position: relative;
  width: 100%;
  height: calc(100% - 68px);
  display: flex;
  flex-flow: column;
  padding-bottom: 0 !important;
}

.right-slider-notification .cross_icon {
  width: 16.09px;
  height: 16.09px;
  cursor: pointer;
}

.title-text {
  font-family: Poppins;
  font-style: normal;
  line-height: 100%;
}

@media (max-width: 767px) {
  .right-slider-notification {
    max-width: 80vw;
  }

  .main {
    padding: 30px;
  }
}

@media (max-width: 479px) {
  .action-mobile {
    flex-wrap: wrap;
    margin-left: 0px;
  }

  .margin-mobile {
    .button-filter {
      margin-top: 10px;
      margin-left: 0px;
    }
  }
}

.scroll-css {
  &::-webkit-scrollbar {
    width: 0px;
  }
}
</style>
